import importExternalScript from '@utils/import-external-library'
import { GOOGLE_API_KEY } from '@src/app.config';

export function importMapApiScript() {
  importExternalScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places&language=en`)
}

/**
 * Helper method to remove keys-value pairs of objects 
 * Note: This method is recursive
 * 
 * @param {*} object the parent object of which to omit values from
 * @param {(string|string[])} field either the field name, or collection of field names to omit
 * @returns the parsed object less all fields to omit, false if data was un-parseable 
 */
export function omitDeep(object, field) {
  if (((typeof field !== 'string' || field === null) && !Array.isArray(field)) || object === null){
    return false
  }
  if (Array.isArray(field)){
    field.forEach(el => {
      object = omitDeep(object, el)
    });
    return object
  }else{
    for(const obj in object) {
      if (obj === field) {
        delete object[field]
        continue;
      }
      if (Array.isArray(object[obj])) {
        object[obj].forEach(el => {
          if (el !== null && (typeof el === 'object' || Array.isArray(el))){
            el = omitDeep(el, field)
          }
        });
      }
      
      if (typeof object[obj] === 'object' && object[obj] !== null) {
        object[obj] = omitDeep(object[obj], field)
      }
    }
    return object
  }
}